import { MessageFactory } from '../../data-models/message-factory';
import DP from '../../facades/data-provider';
import Global from '../../global';
import { eMessageTypesWS } from '../../utils/enums';
import { handle404Error } from '../../utils/error-handling';
import { AppConfigSelectors } from '../app-config';
import { UserContextSelectors } from '../user';
import { Actions } from './actions';
import { getLogDataFromUserContext } from '../../services/clickstream-service/utils';


/**
 * Add sports action creator.
 * @param {ISportsMap} sports - Sports map.
 * @return {function(*): *} - Action dispatcher.
 */
export function addSports(sports) {
  return (dispatch) => dispatch(Actions.addSports(sports));
}

/**
 * Add events action creator.
 * @param {IEventsMap} events - Events map.
 * @return {function(*): *} - Action dispatcher.
 */
export function addEvents(events) {
  return (dispatch) => dispatch(Actions.addEvents(events));
}

/**
 * Add bet offers action creator.
 * @param {ISportsMap} betOffers - Bet offers map.
 * @return {function(*): *} - Action dispatcher.
 */
export function addBetOffers(betOffers) {
  return (dispatch) => dispatch(Actions.addBetOffers(betOffers));
}

export function addParticipants(participants) {
  return (dispatch) => dispatch(Actions.addParticipants(participants));
}

export function addOutcomes(outcomes) {
  return (dispatch) => dispatch(Actions.addOutcomes(outcomes));
}

export function loadQuickLinks() {
  return (dispatch, getState) => {
    const state = getState();
    const { appConfig, userContext } = state;
    const { locale, market, offering } = userContext;
    const { useProdApis } = appConfig;

    const logData = getLogDataFromUserContext(userContext);
    let promise = DP.getQuickLinks(locale, market, offering, logData, useProdApis);

    if (promise) {
      return promise
        .then(quicklinks => {
          dispatch(Actions.loadQuickLinksSuccess(quicklinks));
        })
        .catch(err => {
          Global.logger.error(`err loadQuickLinks ${err}`);
        });
    }
  };
}

export function loadSports() {
  return async (dispatch, getState) => {
    dispatch(Actions.loadSportGroupsRequest());
    try {
      const state = getState();
      const userContext = UserContextSelectors.selectUserContext(state);
      const useProdApis = AppConfigSelectors.selectUseProdApis(state);
      const { locale, market, offering } = userContext;
      const logData = getLogDataFromUserContext(userContext);
      const sportsData = await DP.getSports(locale, market, offering, logData, useProdApis);
      dispatch(Actions.loadSportGroupsSuccess(sportsData));
    } catch (err) {
      dispatch(Actions.loadSportGroupsFailure());
    }
  };
}

/*
export function loadOpenBets() {
  return async (dispatch, getState) => {
    dispatch(Actions.loadOpenBetsRequest());
    try {
      const state = getState();
      const userContext = UserContextSelectors.selectUserContext(state);
      const useProdApis = AppConfigSelectors.selectUseProdApis(state);
      const openBets = await DP.getOpenBets(userContext, useProdApis);
      dispatch(Actions.loadOpenBetsSuccess(openBets));
    } catch (err) {
      dispatch(Actions.loadOpenBetsFailure());
      const options = {
        dispatch,
        actionToDispatch: Actions.loadOpenBets,
        fromApiCall: "loadOpenBets",
        fromFile: "app-data-actions"
      };
      handle404Error(err, options);
    }
  }
}*/

export function loadEventAndBetOffer(eventId) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const userContext = UserContextSelectors.selectUserContext(state);
      const useProdApis = AppConfigSelectors.selectUseProdApis(state);
      const { locale, market, offering } = userContext;
      const logData = getLogDataFromUserContext(userContext);
      const { outcomesMap, betOffersMap, eventsMap, participantsMap } = await DP.getEventsAndBetOffersByEventIds([eventId], locale, market, offering, logData, useProdApis);
      dispatch(Actions.addOutcomes(outcomesMap));
      dispatch(Actions.addBetOffers(betOffersMap));
      dispatch(Actions.addParticipants(participantsMap));
      dispatch(Actions.addEvents(eventsMap));
    } catch (err) {
      const options = {
        dispatch,
        actionToDispatch: Actions.addOutcomes,
        fromApiCall: 'loadEventAndBetOffer',
        fromFile: 'app-data-actions'
      };
      handle404Error(err, options);
    }
  };
}

export function loadBetOffersAndOutcomesForEvent(eventId) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const userContext = UserContextSelectors.selectUserContext(state);
      const useProdApis = AppConfigSelectors.selectUseProdApis(state);
      const { locale, market, offering } = userContext;
      const logData = getLogDataFromUserContext(userContext);
      const { outcomesMap, betOffersMap, eventsMap } = await DP.getBetOffersForEvents([eventId], locale, market, offering, logData, useProdApis);
      dispatch(Actions.addOutcomes(outcomesMap));
      dispatch(Actions.addBetOffers(betOffersMap));
      dispatch(Actions.addEvents(eventsMap));
    } catch (err) {
      Global.logger.error(`err loadBetOffersAndOutcomesForEvent ${err}`);
    }
  };
}

export function addLiveEvent(event) {
  return (dispatch) => dispatch(Actions.addLiveEvent(event));
}

export function removeEvent(eventId) {
  return (dispatch) => dispatch(Actions.removeEvent(eventId));
}

export function updateEventScore(score) {
  return (dispatch) => dispatch(Actions.updateEventScore(score));
}

export function updateMatchClock(matchClock) {
  return (dispatch) => dispatch(Actions.updateMatchClock(matchClock));
}

export function removeMatchClock(eventid) {
  return (dispatch) => dispatch(Actions.removeMatchClock(eventid));
}

export function addBetOffer(betOffer) {
  return (dispatch) => dispatch(Actions.addBetOffer(betOffer));
}

export function removeBetOffer(betOfferId) {
  return (dispatch) => dispatch(Actions.removeBetOffer(betOfferId));
}

export function addBetOfferOdds(outcomes) {
  return (dispatch) => dispatch(Actions.addBetOfferOdds(outcomes));
}

export function removeBetOfferOdds(outcome) {
  return (dispatch) => dispatch(Actions.removeBetOfferOdds(outcome));
}

export function updateBetOfferOdds(outcome) {
  return (dispatch) => dispatch(Actions.updateBetOfferOdds(outcome));
}

export function updateBetOfferStatus(betOfferUpdate) {
  return (dispatch) => dispatch(Actions.updateBetOfferStatus(betOfferUpdate));
}

export function updateEventStats(stats) {
  return (dispatch) => dispatch(Actions.updateEventStats(stats));
}

export function processMessagesFromWS(messageList) {
  return (dispatch, getState) => {

    const state = getState();
    const typeIds = Object.values(eMessageTypesWS);

    messageList.map((messageObj) => {
      if (typeIds.includes(messageObj.mt)) {
        const message = MessageFactory.create(messageObj);

        if (message.isRelevant(state)) {
          message.createActionsForDispatch().forEach((action) => {
            dispatch(action);
          });
        }
      }
    });
  };
}

export function setNewStartForEvent(eventId, startDate) {
  return async (dispatch) => {
    dispatch(Actions.setNewStartForEvent(eventId, startDate));
  };
}

